var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Clock from '@olxbr/olx-icons/dist/System/Clock';
import X from '@olxbr/olx-icons/dist/System/X';
import { Link, VisuallyHidden } from '@olxbr/ds-web';
import { getFriendlyUrl } from '../utils/suggestionUrlFormatter';
var HOME_ICON_SIZE = 22;
var LISTING_HEADER_ICON_SIZE = 18;
var Wrappper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n\n  &:hover {\n    background: var(--color-neutral-light);\n  }\n"])));
var ButtonContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var RemoveHistoryButton = styled.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  ", "\n  ", "\n  right: 12px;\n  height: 32px;\n  width: 32px;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--border-radius-lg);\n  color: var(--color-neutral-dark);\n\n  background: none;\n  cursor: pointer;\n  transition: var(--transition-duration-fast);\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: var(--color-secondary-lighter);\n    color: var(--color-neutral-light);\n  }\n"])), function (_ref) {
  var homeStyle = _ref.homeStyle;
  return homeStyle ? 'top: 9px;' : 'top: 6px;';
}, function (_ref2) {
  var closeSize = _ref2.closeSize;
  return closeSize && 'top: 4px;';
});

var OraculoHistoryItem = function OraculoHistoryItem(_ref3) {
  var _query;

  var query = _ref3.query,
      boldSugg = _ref3.boldSugg,
      suggestion = _ref3.suggestion,
      homeStyle = _ref3.homeStyle,
      indexPosition = _ref3.indexPosition,
      _onClick = _ref3.onClick,
      deleteHistoryItem = _ref3.deleteHistoryItem,
      closeSize = _ref3.closeSize;
  var historySuggestion = suggestion.query;
  var iconSize = homeStyle ? HOME_ICON_SIZE : LISTING_HEADER_ICON_SIZE;
  var closeIconSize = closeSize || iconSize;
  query = (_query = query) === null || _query === void 0 ? void 0 : _query.toLowerCase();
  return /*#__PURE__*/React.createElement(Wrappper, null, /*#__PURE__*/React.createElement(Link, {
    className: "listing-suggestion-item",
    href: getFriendlyUrl(historySuggestion),
    onClick: function onClick(event) {
      return _onClick(event, {
        suggestion: historySuggestion,
        suggestionIndex: indexPosition,
        submitMethod: 'enter'
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "listing-suggestion-item__icon"
  }, /*#__PURE__*/React.createElement(Clock, {
    size: iconSize
  })), /*#__PURE__*/React.createElement("div", {
    className: "history-text"
  }, query, /*#__PURE__*/React.createElement("b", null, boldSugg))), /*#__PURE__*/React.createElement(RemoveHistoryButton, {
    className: "close",
    homeStyle: homeStyle,
    closeSize: closeSize,
    onClick: deleteHistoryItem
  }, /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(X, {
    id: "close",
    size: closeIconSize
  })), /*#__PURE__*/React.createElement(VisuallyHidden, null, "Remover sugest\xE3o do hist\xF3rico")));
};

OraculoHistoryItem.propTypes = process.env.NODE_ENV !== "production" ? {
  query: PropTypes.string,
  boldSugg: PropTypes.string,
  suggestion: PropTypes.shape({
    category: PropTypes.string,
    query: PropTypes.string
  }),
  homeStyle: PropTypes.bool,
  indexPosition: PropTypes.number,
  closeSize: PropTypes.number,
  onClick: PropTypes.func,
  deleteHistoryItem: PropTypes.func
} : {};
export default OraculoHistoryItem;